import { render } from "./settingsModal.vue?vue&type=template&id=7a5e09bc&scoped=true"
import script from "./settingsModal.vue?vue&type=script&lang=js"
export * from "./settingsModal.vue?vue&type=script&lang=js"

import "./settingsModal.vue?vue&type=style&index=0&id=7a5e09bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7a5e09bc"

export default script